import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default {
    name     : "swiper-free-mode",
    _selector: "[data-swiper-free-mode]",
    _swipers : [],
    freeSwiper : null,
    modalSwiper : null,

    init()
    {
        setTimeout(() => this.run(), 1000);
    },

    run()
    {
        this.freeSwiper = this.initFreeSwiper();
        this.modalSwiper = this.initModalSwiper();
        this.initModal();
    },

    initFreeSwiper()
    {
        const swiperFreeMode = document.querySelector('[data-swiper-free-mode]');
        if (! swiperFreeMode) {
            return;
        }

        return new Swiper(swiperFreeMode, {
            loop: false,
            freeMode: true,
            spaceBetween: 0,
            slidesPerView: 1,
            breakpoints: {
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 4,
                },
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
            },
            navigation: {
                nextEl: ".swiper-gallery .swiper-button-next",
                prevEl: ".swiper-gallery .swiper-button-prev",
            },
        });
    },

    initModalSwiper()
    {
        const swiperModal = document.querySelector('[data-swiper-modal]');

        return new Swiper(swiperModal, {
            loop: true,
            spaceBetween: 30,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-modal .swiper-button-next",
                prevEl: ".swiper-modal .swiper-button-prev",
            },
        });

    },

    initModal()
    {
        const buttons = document.querySelectorAll('.toggle-modal-btn');
        if (! buttons.length) {
            return false;
        }

        buttons.forEach((el) => el.addEventListener('click', (event) => {
            const button =  event.target.classList.contains('toggle-modal-btn') ?
                            event.target :
                            event.target.closest('.toggle-modal-btn');

            if (typeof button.dataset.index !== 'undefined') {
                this.modalSwiper.slideTo(parseInt(button.dataset.index)+1);
            }

            document.querySelector('.gallery__modal').classList.toggle('active');
        }));
    }
};